import React from 'react';

// Fake short cinematic "video" loop built from a flavour's neon box image.
// Pure CSS motion: ken-burns zoom, drifting coloured smoke, flickering neon,
// light sweep and rising embers — coloured per flavour.
export default function CinematicClip({ flavour, rounded = 'rounded-2xl', className = '' }) {
  const f = flavour;
  const embers = [
    { l: '18%', s: 4, d: 3.4, delay: 0 },
    { l: '34%', s: 3, d: 4.2, delay: 1.1 },
    { l: '52%', s: 5, d: 3.8, delay: 0.6 },
    { l: '68%', s: 3, d: 4.6, delay: 1.8 },
    { l: '82%', s: 4, d: 3.2, delay: 0.3 },
  ];
  return (
    <div
      className={`absolute inset-0 overflow-hidden ${rounded} ${className}`}
      style={{ ['--flavour-primary']: f.primary, ['--flavour-rgb']: f.rgb }}
    >
      {/* base scene with slow ken-burns motion */}
      <img src={f.box} alt="" aria-hidden="true" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover ken-burns" />

      {/* colour grade + darken */}
      <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(0,0,0,0.1), rgba(0,0,0,0.55))' }} />
      <div className="absolute inset-0 mix-blend-overlay" style={{ background: `radial-gradient(ellipse at 50% 55%, rgba(${f.rgb},0.5), transparent 72%)` }} />

      {/* drifting coloured smoke */}
      <div className="absolute inset-0 smoke-drift" style={{ background: `radial-gradient(closest-side at 32% 42%, rgba(${f.rgb},0.55), transparent 62%)`, filter: 'blur(34px)' }} />

      {/* flickering neon bars */}
      <div className="absolute inset-y-[6%] left-[7%] w-[3px] neon-flicker" style={{ background: f.primary, boxShadow: `0 0 34px 7px rgba(${f.rgb},0.85)` }} />
      <div className="absolute inset-y-[6%] right-[7%] w-[3px] neon-flicker" style={{ background: f.primary, boxShadow: `0 0 34px 7px rgba(${f.rgb},0.85)`, animationDelay: '0.7s' }} />

      {/* rising embers */}
      {embers.map((e, i) => (
        <span
          key={i}
          className="absolute rounded-full spark"
          style={{
            left: e.l, bottom: '12%', width: e.s, height: e.s,
            background: f.primary,
            boxShadow: `0 0 ${e.s * 2.5}px ${e.s}px rgba(${f.rgb},0.6)`,
            animationDuration: `${e.d}s`, animationDelay: `${e.delay}s`,
          }}
        />
      ))}

      {/* light sweep */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="light-sweep absolute top-0 h-full w-1/3" style={{ background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.16), transparent)' }} />
      </div>

      {/* grain + vignette */}
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)', backgroundSize: '3px 3px' }} />
      <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse at center, transparent 52%, rgba(0,0,0,0.78))' }} />
    </div>
  );
}
